import { IPrivateEndpointMetadata as IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getCognitiveServicesControls, cognitiveServicesResourceIdFormat, cognitiveServicesResourceIdErrorMessage } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const azureCognitiveServicesPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.CognitiveServices/accounts',
    connectionSuffix: 'accessControl',
    resourceIdValidator: cognitiveServicesResourceIdFormat,
    groupIdMetadata: {
        account: {
            linkedServiceType: adfModelTypeMap.cognitiveService.linkedServiceType,
            groupId: 'account',
            iconClass: 'svg-cognitive-services',
            displayName: stringResources.CognitiveServices,
            controls: {
                creationControls: getCognitiveServicesControls(),
                readonlyControls: getReadonlyControl(cognitiveServicesResourceIdFormat, cognitiveServicesResourceIdErrorMessage)
            }
        }
    }
};
